import AddIcon from '@mui/icons-material/Add'

import Button from 'components/Button'
import useCanAccess from 'hooks/useCanAccess'
import userActions from 'utils/constants/userActions'

interface CreateButtonProps {
  resource: string
  onCreate: () => void
}

const CreateButton = ({ resource, onCreate }: CreateButtonProps) => {
  return useCanAccess({ resource, action: userActions.CREATE }) ? (
    <Button
      label="Create"
      onClick={onCreate}
      color="primary"
      startIcon={<AddIcon />}
      disabled={false}
      variant="contained"
    />
  ) : null
}

export default CreateButton
